import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import DatePickerProps from './DatePickerProps'

import Animation from '../Common/Animation'
import Month from '../Common/Month'

export default {
    props: DatePickerProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Animation,
        Month
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoDatePicker(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function () {
            that.$emit('changemodel', that.$refs.valueInput.value)
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDatePicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDatePicker/KendoDatePickerMixin.js